import { Intro } from '@affine/component';
import { WelcomeTooltip, ApplyTooltip, QuoteTooltip } from './pattern';
import { useI18n } from '@affine/i18n';

export const UserGuideIntro = () => {
  const t = useI18n();
  return (
    <Intro
      steps={[
        // chat panel 改为全屏后，删除此引导
        // {
        //   priority: 100,
        //   minWidth: 300,
        //   target: '#welcome-intro-container',
        //   content: t['com.affine.user-guide.muset-ai-handle-everything'](),
        //   placement: 'left-start',
        //   disableOverlayClose: true,
        //   disableOverlay: false,
        //   spotlightClicks: false,
        //   tooltipComponent: WelcomeTooltip,          
        //   styles: {
        //     options: {
        //       arrowColor: '#F7F4EF',
        //       backgroundColor: '#F7F4EF',
        //     },
        //     spotlight: {
        //       borderRadius: 25,
        //     },
        //     overlay: {
        //       // pointerEvents: 'none',
        //     },
        //   },
        // },
        {
          priority: 1,
          target: '.selection-intro-container',
          content: t['com.affine.user-guide.muset-ai-tailors-responses'](),
          placement: 'top',
          disableOverlay: false,
          disableOverlayClose: true,
          spotlightClicks: true,
          tooltipComponent: QuoteTooltip,
          styles: {
            options: {
              arrowColor: '#000',
              backgroundColor: '#000',
            },
            spotlight: {
              borderRadius: 50,
              border: '1px solid #000',
            },
            overlay: {
              backgroundColor: 'none',
            },
          },
        },

        {
          priority: 1,
          target: '#suggestion-operation-intro-container',
          content: t['com.affine.user-guide.check-suggestions-or-apply-all'](),
          placement: 'top',
          disableOverlay: true,
          disableOverlayClose: true,
          spotlightClicks: true,
          tooltipComponent: ApplyTooltip,
          styles: {
            options: {
              arrowColor: '#000',
              backgroundColor: '#000',
            },
            spotlight: {
              borderRadius: 50,
              border: '1px solid #000',
            },
            overlay: {
              backgroundColor: 'none',
            },
          },
        },
      ]}
    />
  );
};
